import PropTypes from 'prop-types';
import { trans } from '@spotahome/soyuz/client';

const AgeRange = ({ minAge, maxAge }) => (
  <li>
    {trans('property_show.instant_booking_modal.age')} {minAge}-{maxAge}
  </li>
);

AgeRange.propTypes = {
  minAge: PropTypes.number,
  maxAge: PropTypes.number
};

AgeRange.defaultProps = {
  minAge: 0,
  maxAge: '99+'
};

export default AgeRange;
